<template>
  <div>
    <div id="app" v-report.visit="{ addition: { award_id: params.award_id } }">
      <div
        class="view-home"
        v-hb-loading="isLoading"
        hb-loading-circle-bg="#DADDE0"
        hb-loading-color="#64696E"
      >
        <div class="outer" v-if="!isLoading">
          <page-nav
            v-if="isLinkGacha"
            logoColor="rgba(255, 255, 255, 0)"
            bg="#fff"
            is-fixed
            scroll-dom-selector=".loadPar"
          ></page-nav>
          <div
            :class="[
              isShare ? 'container share-view' : 'container',
              !isShare && gachaStatus === 4 ? 'container-pbt75' : '',
              isLinkGacha ? 'container-link' : '',
            ]"
            :style="{
              background:
                'linear-gradient(to right, ' +
                bgColorLeft +
                ' 0%, ' +
                bgColorRight +
                ' 100%)',
              paddingTop: isLinkGacha
                ? [1, 2, 7, 8].includes(gachaStatus)
                  ? navHeight + 142 + 'px'
                  : navHeight + 20 + 'px'
                : '62px',
            }"
            ref="gacha"
            class="loadPar"
          >
            <!-- 轮播消息 -->
            <div
              :class="isShowCarousel ? 'carousel show' : 'carousel'"
              :style="{ top: isLinkGacha ? navHeight + 'px' : '16px' }"
              v-if="messageList.length > 0"
            >
              <cptCarousel
                :carousel="carousel"
                :mainColor="mainColor"
                :fontColor="fontColor"
              ></cptCarousel>
            </div>
            <!-- 头图 -->
            <template v-if="!isLinkGacha">
              <div class="img-head" v-if="awardInfo.award_img_type === 0">
                <img :src="awardInfo.award_img" />
              </div>
              <div class="img-real" v-else>
                <img :src="awardInfo.award_img" />
              </div>
            </template>
            <div
              class="countdown"
              v-if="isLinkGacha && [1, 2, 7, 8].includes(gachaStatus)"
              :style="{ top: navHeight + 42 + 'px' }"
            >
              <cpt-countdown
                :fontColor="fontColor"
                :endTime="awardInfo.award_end_time"
                @refresh="getData"
              ></cpt-countdown>
            </div>
            <!-- 主界面/分享页-->
            <div class="main" v-if="!isShare">
              <div :class="gachaStatus === 2 ? 'name margin-short' : 'name'">
                {{
                  isLinkGacha
                    ? `${awardInfo.award_detail}*${awardInfo.award_number}`
                    : awardInfo.award_name
                }}
              </div>
              <div class="lottery">
                <div class="text">
                  <div
                    class="text-inner"
                    v-if="gachaStatus === 1 && !isLinkGacha"
                  >
                    <div class="img" :style="mainColor">
                      <img src="./assets/images/ticket_tra.png" />
                    </div>
                    <div :style="fontColor">当前已获得100盒劵助力</div>
                  </div>
                  <div
                    class="text-inner"
                    v-if="gachaStatus === 2 && !isLinkGacha"
                    @click="openMyLottery(true)"
                  >
                    <div class="img" :style="mainColor">
                      <img src="./assets/images/ticket_tra.png" />
                    </div>
                    <div :style="fontColor">我的盒券：</div>
                    <div class="myticket">
                      <span class="bold red" :style="fontColor">{{
                        myTicket
                      }}</span>
                    </div>
                    <div class="arrow" :style="mainColor">
                      <img src="./assets/images/arrow_tra.png" />
                    </div>
                  </div>
                  <div class="text-inner" v-if="gachaStatus === 3">
                    <div :style="fontColor" class="over">差一点就中奖啦</div>
                    <div class="img">
                      <img src="./assets/images/thick.png" />
                    </div>
                  </div>
                  <div class="text-inner" v-if="gachaStatus === 4">
                    <div class="img"><img src="./assets/images/cle.png" /></div>
                    <div :style="fontColor" class="over">恭喜你中奖啦</div>
                    <div class="img"><img src="./assets/images/cle.png" /></div>
                  </div>
                  <div
                    class="text-inner front-task"
                    v-if="gachaStatus === 7 && !isLinkGacha"
                  >
                    <div :style="fontColor">
                      {{ frontTask.task_name }}即可参与抽奖
                    </div>
                  </div>
                </div>
              </div>
              <div class="gacha" v-if="gachaStatus === 1">
                <div class="btn" :style="mainColor" @click="gacha()">
                  <span>参与抽奖</span>
                </div>
              </div>
              <div class="gacha" v-else-if="gachaStatus === 2">
                <div
                  class="btn"
                  :class="{ 'no-animate': isLinkGacha }"
                  :style="mainColor"
                  @click="needHelp()"
                  v-if="!this.isMax"
                >
                  <span>{{
                    isLinkGacha ? '已参与，等待开奖' : '立即邀请好友助力'
                  }}</span>
                </div>
                <div class="btn" :style="mainColor" v-else>
                  <span>完成下方任务获取更多盒券</span>
                </div>
              </div>
              <!-- gachaStatus=6表示参该抽奖处于结算状态 -->
              <div class="gacha" v-else-if="gachaStatus === 6">
                <div class="btn" :style="mainColor">
                  <span>结算中，请稍后</span>
                </div>
              </div>
              <!-- 没做前置任务 -->
              <div
                class="gacha"
                v-else-if="gachaStatus === 7 || gachaStatus === 8"
                @click="finishFrontTask()"
              >
                <div class="btn" :style="mainColor">
                  <span>{{
                    isLinkGacha
                      ? '完成全部任务参与抽奖'
                      : '一键完成任务参与抽奖'
                  }}</span>
                </div>
              </div>
              <div class="time">
                <span>{{ awardInfo.award_end_time }} 开奖</span>
                <span class="sep"></span>
                <span class="rule" @click="isShowRules = true">抽奖规则</span>
                <span class="sep" v-if="detailText !== ''"></span>
                <span
                  @click="isShowDetail = true"
                  v-if="!isLinkGacha && detailText !== ''"
                >
                  <span class="rule">奖品信息</span>
                </span>
              </div>
              <div class="result" v-if="gachaStatus === 3">
                <div class="label">获奖名单</div>
                <div class="lucky-outer gt" v-if="awardInfo.award_number > 10">
                  <div
                    class="lucky"
                    v-for="(item, index) in awardInfo.winner_list"
                    :key="index"
                    @click="openTaLottery(item, true)"
                  >
                    <div class="avatar">
                      <img :src="item.heybox_info.avatar" />
                    </div>
                    <div class="lucky-name">
                      {{ item.heybox_info.username }}
                    </div>
                    <template v-if="!isLinkGacha">
                      <div class="code">盒券编号: {{ item.ticket_number }}</div>
                      <div class="arrow" style="background: #64696e">
                        <img src="./assets/images/arrow_tra.png" />
                      </div>
                    </template>
                  </div>
                  <div class="checkall" @click="toAllWinner(false)">
                    <div>全部名单</div>
                    <div class="img">
                      <img src="./assets/images/arrow-right.png" />
                    </div>
                  </div>
                </div>
                <div class="lucky-outer lt" v-else>
                  <div
                    class="lucky"
                    v-for="(item, index) in awardInfo.winner_list"
                    :key="index"
                    @click="openTaLottery(item, true)"
                  >
                    <div class="avatar">
                      <img :src="item.heybox_info.avatar" />
                    </div>
                    <div class="lucky-name">
                      {{ item.heybox_info.username }}
                    </div>
                    <template v-if="!isLinkGacha">
                      <div class="code">盒券编号: {{ item.ticket_number }}</div>
                      <div class="arrow" style="background: #64696e">
                        <img src="./assets/images/arrow_tra.png" />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="total">共{{ awardInfo.joined_total }}人参与</div>
              </div>
              <div
                class="result red"
                :style="mainColor"
                v-else-if="gachaStatus === 4"
              >
                <div class="label">获奖名单</div>
                <div class="lucky-outer gt" v-if="awardInfo.award_number > 10">
                  <div
                    class="lucky"
                    v-for="(item, index) in awardInfo.winner_list"
                    :key="index"
                    @click="openTaLottery(item, true)"
                  >
                    <div class="avatar">
                      <img :src="item.heybox_info.avatar" />
                    </div>
                    <div class="lucky-name">
                      {{ item.heybox_info.username }}
                    </div>
                    <template v-if="!isLinkGacha">
                      <div class="code">盒券编号: {{ item.ticket_number }}</div>
                      <div class="arrow">
                        <img src="./assets/images/arrow-white.png" alt="" />
                      </div>
                    </template>
                  </div>
                  <div class="checkall" @click="toAllWinner(true)">
                    <div>全部名单</div>
                    <div class="img">
                      <img src="./assets/images/arrow-right-white.png" />
                    </div>
                  </div>
                </div>
                <div class="lucky-outer lt" v-else>
                  <div
                    class="lucky"
                    v-for="(item, index) in awardInfo.winner_list"
                    :key="index"
                    @click="openTaLottery(item, true)"
                  >
                    <div class="avatar">
                      <img :src="item.heybox_info.avatar" />
                    </div>
                    <div class="lucky-name">
                      {{ item.heybox_info.username }}
                    </div>
                    <template v-if="!isLinkGacha">
                      <div class="code">盒券编号: {{ item.ticket_number }}</div>
                      <div class="arrow">
                        <img src="./assets/images/arrow-white.png" alt="" />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="total">共{{ awardInfo.joined_total }}人参与</div>
              </div>
              <!-- 如果是帖子抽奖，展示前置任务 -->
              <div
                class="task"
                v-if="
                  gachaStatus === 2 ||
                  ([1, 7, 8].includes(gachaStatus) && isLinkGacha)
                "
              >
                <div class="label">盒券任务</div>
                <div
                  class="content-task"
                  v-for="(item, index) in taskList"
                  :key="index"
                  :style="item.finished ? 'opacity: 0.4' : ''"
                  @click="
                    () =>
                      isLinkGacha ? finishFrontTask(item) : finishTask(item)
                  "
                >
                  <div class="icon" :style="mainColor">
                    <img :src="item.icon" />
                  </div>
                  <div class="text">
                    <div v-if="isLinkGacha" class="desc">
                      {{ item.task_name }}
                    </div>
                    <template v-else>
                      <div class="desc">
                        {{ item.task_name }}
                        <span :style="fontColor" v-if="item.progress"
                          >{{ item.progress[0] }}/{{ item.progress[1] }}</span
                        >
                      </div>
                      <div
                        class="lottery-num"
                        v-if="item.progress"
                        :style="fontColor"
                      >
                        +{{ item.award_ticket }}盒券/次
                      </div>
                      <div class="lottery-num" v-else :style="fontColor">
                        +{{ item.award_ticket }}盒券
                      </div>
                    </template>
                  </div>
                  <div class="finish" :style="mainColor" v-if="!item.finished">
                    去完成
                  </div>
                  <div class="finish" :style="mainColor" v-else>已完成</div>
                  <div class="after" v-if="index !== taskList.length - 1"></div>
                </div>
                <div
                  class="tips"
                  v-if="!isLinkGacha"
                  :style="{
                    background:
                      'linear-gradient(to right, ' +
                      bgColorLeft +
                      ' 0%, ' +
                      bgColorRight +
                      ' 100%)',
                  }"
                >
                  中奖小贴士：分享到至少3个玩家的群，可获得大量盒券助力
                </div>
              </div>
              <div class="link-card" v-if="isLinkGacha && link">
                <p class="card-title">活动链接</p>
                <div class="link-box" @click="toLinkPage">
                  <div class="link-info">
                    <p class="link-title">{{ link.title }}</p>
                    <p class="link-desc">
                      <span class="link-comment">{{
                        `${link.comment_num}评论·${link.topics.length ? link.topics[0].name : ''}`
                      }}</span>
                      <span class="create-time">{{
                        formDate(link.create_at, 2)
                      }}</span>
                    </p>
                  </div>
                  <div class="link-img" v-if="link.imgs && link.imgs.length">
                    <img :src="link.imgs[0]" alt="" />
                  </div>
                </div>
              </div>
              <div class="spearator"></div>
              <div class="owner" @click="toOwner()" v-if="owner">
                <div class="avatar">
                  <img :src="owner.avatar" />
                </div>
                <div class="owner-desc">
                  <div class="name">
                    <span
                      class="owner-label"
                      :style="
                        'background: linear-gradient(to right, ' +
                        btnColorLeft +
                        ' 0%, ' +
                        btnColorRight +
                        ' 100%)'
                      "
                      >房主</span
                    >
                    {{ owner.username }}
                  </div>
                  <div class="sign">{{ owner.signature }}</div>
                </div>
                <div
                  class="up-btn done"
                  :style="mainColor"
                  v-if="owner.focused"
                >
                  已关注
                </div>
                <div
                  class="up-btn"
                  :style="mainColor"
                  @click.stop="upOwner()"
                  v-else
                >
                  <img src="./assets/images/add.png" />
                  关注
                </div>
              </div>
              <div class="spearator"></div>
              <div class="participant" v-if="participantList.length > 0">
                <div class="label">
                  <span
                    >已有{{ awardInfo.joined_total }}人参与
                    <span v-if="awardInfo.award_number > 1 && !isLinkGacha"
                      >- {{ awardInfo.award_number }}份</span
                    ></span
                  >
                  <span class="total-tickets" v-if="!isLinkGacha"
                    >总盒券数{{ awardInfo.total_ticket }}张</span
                  >
                </div>
                <hb-list
                  class="list"
                  :finishedText="''"
                  :finished="participantsNoMore"
                  @load="loadPar"
                  :offset="50"
                >
                  <div
                    class="user"
                    v-for="(item, index) in participantList"
                    :key="index"
                    @click="openTaLottery(item, true)"
                  >
                    <div class="avatar" @click.stop="openUser(item)">
                      <img :src="item.heybox_info.avatar" />
                    </div>
                    <div class="user-name">{{ item.heybox_info.username }}</div>
                    <div class="ban" v-if="item.baned">作弊封禁</div>
                    <template v-if="!isLinkGacha">
                      <div class="lottery-num">{{ item.ticket_number }}张</div>
                      <div class="arrow" style="background: #c8cdd2">
                        <img src="./assets/images/arrow_tra.png" />
                      </div>
                    </template>
                  </div>
                </hb-list>
              </div>
            </div>
            <div
              class="main share"
              :class="{ 'link-gacha': isLinkGacha }"
              v-else
            >
              <template v-if="!isLinkGacha">
                <div v-if="gachaStatus === 3 || gachaStatus === 4">
                  <div class="name">{{ awardInfo.award_name }}</div>
                  <div class="gacha">
                    <div
                      class="btn"
                      :style="
                        'background: linear-gradient(to right, ' +
                        btnColorLeft +
                        ' 0%, ' +
                        btnColorRight +
                        ' 100%)'
                      "
                      @click="openInApp()"
                    >
                      <span>前往APP参与抽奖</span>
                    </div>
                  </div>
                  <div class="toApp">
                    <div class="icon" :style="mainColor">
                      <img src="./assets/images/ticket_tra.png" />
                    </div>
                    <div class="text red" :style="fontColor">
                      您已经获得100倍中奖机会
                    </div>
                  </div>
                </div>
                <div v-else-if="gachaStatus === 2">
                  <div class="name">{{ awardInfo.award_name }}</div>
                  <div class="gacha">
                    <div
                      class="btn"
                      :style="mainColor"
                      @click="gotoApp()"
                      v-if="!isHelp && !login"
                    >
                      <span>前往小黑盒APP为好友助力</span>
                    </div>
                    <div
                      class="btn"
                      :style="mainColor"
                      @click="helpFriend()"
                      v-else-if="!isHelp && login"
                    >
                      <span>为好友助力</span>
                    </div>
                    <div
                      class="btn"
                      :style="mainColor"
                      @click="gotoGachaView()"
                      v-else
                    >
                      <span>助力成功，前往参与抽奖</span>
                    </div>
                  </div>
                  <div class="lottery">
                    <div class="text">
                      <div class="text-inner">
                        <div class="img" :style="mainColor">
                          <img src="./assets/images/ticket_tra.png" />
                        </div>
                        <div class="red" :style="fontColor">
                          同时获得100倍中奖机会
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="helper">
                    <div class="helper-list">
                      <div
                        class="helper-info"
                        v-for="(item, index) in helperList"
                        :key="item.heybox_id"
                      >
                        <div class="avatar">
                          <img :src="item.avatar" />
                        </div>
                      </div>
                      <div
                        class="no-helper"
                        v-for="(item, index) in 5 - helperList.length"
                        :key="item.heybox_id"
                        @click="helpToApp()"
                      >
                        <div class="no-avatar">
                          <img
                            src="./assets/images/add_grey.png"
                            style="width: 18px; height: 18px"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="helper-num">
                      已有 {{ helperList.length }} 名好友助力
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="name">{{ awardInfo.award_name }}</div>
                  <div class="gacha">
                    <div class="btn" :style="mainColor" @click="openInApp()">
                      <span>前往APP参与抽奖</span>
                    </div>
                  </div>
                  <div class="lottery">
                    <div class="text">
                      <div class="text-inner">
                        <div class="img" :style="mainColor">
                          <img src="./assets/images/ticket_tra.png" />
                        </div>
                        <div :style="fontColor">同时获得100倍中奖机会</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="name">{{ awardInfo.award_name }}</div>
                <div class="gacha">
                  <div
                    class="btn"
                    :style="
                      'background: linear-gradient(to right, ' +
                      btnColorLeft +
                      ' 0%, ' +
                      btnColorRight +
                      ' 100%)'
                    "
                    @click="openInApp"
                  >
                    <span>参与抽奖</span>
                  </div>
                </div>
                <div class="time">
                  <span>{{ awardInfo.award_end_time }} 开奖</span>
                  <span class="sep"></span>
                  <span class="rule" @click="openInApp">抽奖规则</span>
                </div>
                <div class="task">
                  <div class="label">盒券任务</div>
                  <div
                    class="content-task"
                    v-for="(item, index) in taskList"
                    :key="index"
                    :style="item.finished ? 'opacity: 0.4' : ''"
                    @click="openInApp"
                  >
                    <div class="icon" :style="mainColor">
                      <img :src="item.icon" />
                    </div>
                    <div class="text">
                      <div class="desc">{{ item.task_name }}</div>
                    </div>
                    <div
                      class="after"
                      v-if="index !== taskList.length - 1"
                    ></div>
                  </div>
                </div>
                <div class="link-card" v-if="link">
                  <p class="card-title">活动链接</p>
                  <div class="link-box" @click="openInApp">
                    <div class="link-info">
                      <p class="link-title">{{ link.title }}</p>
                      <p class="link-desc">
                        <span class="link-comment">{{
                          `${link.comment_num}评论${link.topics.length ? link.topics[0].name : ''}`
                        }}</span>
                        <span class="create-time">{{
                          formDate(link.create_at, 2)
                        }}</span>
                      </p>
                    </div>
                    <div class="link-img" v-if="link.imgs && link.imgs.length">
                      <img :src="link.imgs[0]" alt="" />
                    </div>
                  </div>
                </div>
                <div class="spearator"></div>
                <div class="owner" @click="openInApp" v-if="owner">
                  <div class="avatar">
                    <img :src="owner.avatar" />
                  </div>
                  <div class="owner-desc">
                    <div class="name">
                      <span
                        class="owner-label"
                        :style="
                          'background: linear-gradient(to right, ' +
                          btnColorLeft +
                          ' 0%, ' +
                          btnColorRight +
                          ' 100%)'
                        "
                        >房主</span
                      >
                      {{ owner.username }}
                    </div>
                    <div class="sign">{{ owner.signature }}</div>
                  </div>
                  <div
                    class="up-btn"
                    :style="mainColor"
                    @click.stop="openInApp"
                  >
                    <img src="./assets/images/add.png" />
                    关注
                  </div>
                </div>
                <div class="spearator"></div>
                <div class="participant" v-if="participantList.length > 0">
                  <div class="label">
                    <span>已有{{ awardInfo.joined_total }}人参与</span>
                  </div>
                  <hb-list
                    class="list"
                    :finishedText="''"
                    :finished="participantsNoMore"
                    @load="loadPar"
                    :offset="50"
                  >
                    <div
                      class="user"
                      v-for="(item, index) in participantList"
                      :key="index"
                      @click="openInApp"
                    >
                      <div class="avatar" @click.stop="openInApp">
                        <img :src="item.heybox_info.avatar" />
                      </div>
                      <div class="user-name">
                        {{ item.heybox_info.username }}
                      </div>
                      <div class="ban" v-if="item.baned">作弊封禁</div>
                    </div>
                  </hb-list>
                </div>
              </template>
            </div>
            <!-- 分享页数据内容 -->
            <view-share-award
              :main-award-info="awardInfo"
              :awardList="moreList"
              v-if="moreList.length != 0 && !isLinkGacha"
            ></view-share-award>
          </div>
          <!-- 底部按钮 -->
          <div class="bottom-btn" v-if="!isShare && gachaStatus === 4">
            <div class="btn" :style="mainColor" @click="receive()">
              {{
                is_addressed
                  ? is_delivered
                    ? '查看奖品'
                    : '更改收货地址'
                  : '点此领奖'
              }}
            </div>
          </div>
          <div class="bottom-btn" v-if="isShare">
            <div
              class="btn"
              :style="mainColor"
              v-if="!isShowHelp && !login"
              @click="openInApp()"
            >
              前往小黑盒APP参与抽奖
            </div>
            <div
              class="btn"
              :style="mainColor"
              v-if="login"
              @click="gotoGachaView()"
            >
              点击参与抽奖
            </div>
          </div>
          <template v-if="!isLinkGacha">
            <!-- 我的盒券 -->
            <div :class="isShowMyLottery ? 'my-lottery show ta' : 'my-lottery'">
              <div class="label">
                <span class="mine">我的盒券</span>
                <div class="close" @click="closeLottery()">
                  <img src="./assets/images/close.png" />
                </div>
              </div>
              <div class="lottery-num">
                <span :style="fontColor">当前盒券</span
                ><span class="bold" :style="fontColor">{{ totalTicket }}</span
                ><span :style="fontColor"
                  >张，中奖几率提高{{ totalTicket }}倍</span
                >
              </div>
              <hb-list
                class="lottery-list"
                ref="myLottery"
                :finishedText="''"
                :finished="myTicketsNoMore"
                @load="loadMyLottery"
              >
                <div
                  class="lottery-item"
                  v-for="(item, index) in lotteryList"
                  :key="index"
                >
                  <!-- 内凹圆角遮罩 -->
                  <div class="round1"></div>
                  <div class="round2"></div>
                  <div class="code">盒券编号： {{ item.serial_number }}</div>
                  <div class="lottery-info">
                    <div class="avatar" :style="mainColor">
                      <img
                        :src="
                          item.helper_info ? item.helper_info.avatar : item.icon
                        "
                        :class="item.helper_info ? 'avatar-img' : 'icon-img'"
                      />
                    </div>
                    <div class="text">
                      <div class="method">{{ item.ticket_source }}</div>
                      <div class="time">{{ item.gain_time }}</div>
                    </div>
                    <div class="num">
                      <span class="bold" :style="fontColor">{{
                        item.ticket_count
                      }}</span>
                      <span :style="fontColor">张</span>
                    </div>
                  </div>
                </div>
              </hb-list>
            </div>
            <!-- Ta的盒券 -->
            <div :class="isShowTaLottery ? 'my-lottery show ta' : 'my-lottery'">
              <div class="label">
                <div class="mine">
                  <div class="img">
                    <img :src="TaAvatar" />
                  </div>
                  <div class="name">{{ TaName }}的盒券</div>
                </div>
                <div class="close" @click="closeLottery()">
                  <img src="./assets/images/close.png" />
                </div>
              </div>
              <div
                class="lottery-num"
                v-if="gachaStatus !== 3 && gachaStatus !== 4"
              >
                <span :style="fontColor">当前盒券</span
                ><span class="bold" :style="fontColor">{{ totalTicket }}</span
                ><span :style="fontColor">张</span>
              </div>
              <div class="lottery-num result" v-else>
                <span class="normal"
                  >{{ awardInfo.award_end_time }} Steam客服请求数为</span
                >
                <span :style="fontColor">{{
                  awardInfo.result_info.steam_user_logged_in
                }}</span
                ><br />
                <span class="normal">根据抽奖规则得到随机数A为</span>
                <span :style="fontColor">{{
                  awardInfo.result_info.steam_user_logged_in_233
                }}</span
                ><br />
                <span class="normal">奖券数量B为</span>
                <span :style="fontColor">{{
                  awardInfo.result_info.total_ticket_number
                }}</span>
              </div>
              <div
                class="lucky-number"
                :style="fontColor"
                v-if="(gachaStatus === 3 || gachaStatus === 4) && luckyNum"
              >
                中奖编号为 {{ luckyNum }}
              </div>
              <hb-list
                :class="
                  gachaStatus === 3 || gachaStatus === 4
                    ? 'lottery-list pad-luck'
                    : 'lottery-list'
                "
                ref="taLottery"
                :finishedText="''"
                :finished="taTicketsNoMore"
                @load="loadTaLottery"
              >
                <div
                  class="lottery-item"
                  :style="item.red ? mainColor : ''"
                  v-for="(item, index) in lotteryList"
                  :key="index"
                >
                  <!-- 内凹圆角遮罩 -->
                  <div class="round1"></div>
                  <div class="round2"></div>
                  <div class="code" :style="item.red ? 'color: #FFFFFF' : ''">
                    盒券编号： {{ item.serial_number }}
                  </div>
                  <div class="lottery-info">
                    <div class="avatar" :style="mainColor">
                      <img
                        :src="
                          item.helper_info ? item.helper_info.avatar : item.icon
                        "
                        :class="item.helper_info ? 'avatar-img' : 'icon-img'"
                      />
                    </div>
                    <div class="text">
                      <div
                        class="method"
                        :style="item.red ? 'color: #FFFFFF' : ''"
                      >
                        {{ item.ticket_source }}
                      </div>
                      <div
                        class="time"
                        :style="item.red ? 'color: #FFFFFF' : ''"
                      >
                        {{ item.gain_time }}
                      </div>
                    </div>
                    <div class="num">
                      <span
                        :style="item.red ? 'color: #FFFFFF' : fontColor"
                        class="bold"
                        >{{ item.ticket_count }}</span
                      >
                      <span :style="item.red ? 'color: #FFFFFF' : fontColor"
                        >张</span
                      >
                    </div>
                  </div>
                </div>
              </hb-list>
            </div>
          </template>
          <!-- 中奖规则 -->
          <div :class="isShowRules ? 'rules show' : 'rules'">
            <cptRules :is-link-gacha="isLinkGacha"></cptRules>
          </div>
          <!-- 奖品信息 -->
          <div :class="isShowDetail ? 'detail show' : 'detail'">
            <cptDetail
              :detailText="detailText"
              @closeDetail="clearAll()"
            ></cptDetail>
          </div>
          <!-- 助力 -->
          <div :class="isShowHelp ? 'help show-help' : 'help'">
            <div class="label">
              <span class="mine">登录即可为好友助力100盒券</span>
            </div>
            <div class="desc">
              <span class="text">提高100倍中奖机会</span>
            </div>
            <div class="tel">
              <div class="tel-input">
                <input
                  type="number"
                  v-model="phoneNumber"
                  placeholder="输入手机号"
                  class="inner"
                />
              </div>
              <div class="code">
                <div class="code-input">
                  <input
                    type="number"
                    v-model="code"
                    placeholder="输入验证码"
                    class="inner"
                  />
                </div>
                <div class="btn" @click="sendCode()" v-if="!isSend">
                  发送验证码
                </div>
                <div class="btn done" v-else>已发送 ({{ timeDown }})</div>
              </div>
            </div>
            <div class="declare">
              未注册手机号登录后将自动创建账号，注册即代表你同意《小黑盒服务及隐私条款》
            </div>
          </div>
          <!-- 弹窗 -->
          <div class="dialog gacha" v-if="gaChaDialogVisible">
            <div class="label">
              <span class="label-img"
                ><img src="./assets/images/cle.png"
              /></span>
              <span>参与成功</span>
            </div>
            <div class="text" style="white-space: nowrap">
              您已获得100盒券奖励，中奖几率提高100倍。
              <br />
              邀请好友助力，每一人助力可获得100盒券。
              <br />
              完成盒券任务可获得额外奖励
            </div>
            <div
              class="btn"
              :style="mainColor"
              @click="needHelp()"
              v-if="!isMax"
            >
              立即邀请好友助力
            </div>
            <div
              class="btn"
              :style="mainColor"
              @click="closeGachaDialog()"
              v-else
            >
              确认
            </div>
          </div>
          <div class="dialog front-task" v-if="frontTaskDialogVisible">
            <div class="label">
              <span class="label-img"
                ><img src="./assets/images/cle.png"
              /></span>
              <span>任务审核中</span>
            </div>
            <div class="text">
              {{ frontTask.tips_desc }}
            </div>
            <div class="btn" :style="mainColor" @click="closeGachaDialog()">
              确定
            </div>
          </div>
          <div class="dialog receive" v-if="receiveDialogVisible">
            <div v-if="awardInfo.award_type === 1">
              <div class="label" :style="fontColor">当期奖品</div>
              <div class="name">
                {{ awardInfo.award_name }}
              </div>
              <div class="img">
                <img :src="awardInfo.award_img" />
              </div>
              <div class="btn" :style="mainColor" @click="closeDialog()">
                确定
              </div>
            </div>
            <div v-else>
              <div class="label" v-if="awardInfo.is_winner">
                领取你的游戏兑换码
              </div>
              <div class="label" v-else>当期奖品</div>
              <div class="name">
                {{ awardInfo.award_name }}
              </div>
              <div class="img">
                <img :src="awardInfo.award_img" />
              </div>
              <div class="copy-cdkey" v-if="awardInfo.is_winner">
                <div class="cdkey">
                  {{ awardInfo.obtained_cdkey }}
                </div>
                <div
                  class="copy-btn cdkey-btn"
                  :style="mainColor"
                  :data-clipboard-text="awardInfo.obtained_cdkey"
                  @click="copyCdkey()"
                >
                  复制
                </div>
              </div>
              <div class="desc" v-if="awardInfo.is_winner">
                {{ awardInfo.award_desc }}
              </div>
              <div class="btn" :style="mainColor" @click="closeDialog()">
                确定
              </div>
            </div>
          </div>

          <div class="dialog receive invite" v-if="inviteDialogVisible">
            <div class="label">您的邀请码为</div>
            <div class="copy-cdkey">
              <div class="cdkey">
                {{ inviteCode }}
              </div>
            </div>
            <div class="desc">
              请将邀请码发送给新用户，新用户在注册时填写即可（PS:一台设备只能填写一次邀请码）
            </div>
            <div
              class="btn invite-btn"
              :style="mainColor"
              :data-clipboard-text="inviteCode"
              @click="copyCdkey(true)"
            >
              复制
            </div>
          </div>

          <div class="dialog receive" v-if="receiveSuccessDialogVisible">
            <div class="label">您已填写收货信息</div>
            <div class="name">
              {{ awardInfo.award_name }}
            </div>
            <div class="img">
              <img :src="awardInfo.award_img" />
            </div>
            <div class="text">盒娘将加急发货，请耐心等待</div>
            <div class="btn" :style="mainColor" @click="closeDialog()">
              确定
            </div>
          </div>

          <div
            class="cover lottery"
            @click="clearAll()"
            v-if="isShowHelp || isShowRules || isShowDetail"
          ></div>
          <div
            class="cover lottery"
            @click="closeLottery()"
            v-if="isShowMyLottery || isShowTaLottery"
          ></div>
          <div
            class="cover dialog-cover"
            @click="closeDialog()"
            v-if="
              addLotteryDialogVisible ||
              blankLotteryDialogVisible ||
              receiveDialogVisible ||
              receiveSuccessDialogVisible ||
              inviteDialogVisible
            "
          ></div>
          <div
            class="cover dialog-cover"
            @click="closeGachaDialog()"
            v-if="gaChaDialogVisible || frontTaskDialogVisible"
          ></div>
        </div>
      </div>
    </div>

    <!-- 实物获奖弹窗：填写收货地址之后 -->
    <hb-modal :visible.sync="deliverSuccessModalVisible" class="prize-receive">
      <template>
        <div class="prize-img">
          <img :src="awardInfo.award_img" alt="" />
        </div>
        <div class="close-icon" @click="deliverSuccessModalVisible = false">
          <img src="./assets/images/close.png" alt="" />
        </div>
        <div class="prize-info">
          <p class="prize-name">
            {{ awardInfo.award_name }}
          </p>
          <p class="prize-text">物流配送中，请耐心等待</p>
          <div class="express-box">
            <div class="express-info">
              <div class="express-company">
                <p>{{ express_info.express_company }}</p>
              </div>
              <div class="express-number">
                <p>{{ express_info.express_code }}</p>
              </div>
            </div>
            <div
              class="copy-button"
              :style="mainColor"
              @click="copy"
              :data-clipboard-text="express_info.express_code"
            >
              <p>复制</p>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div
          class="prize-btn"
          :style="mainColor"
          @click="deliverSuccessModalVisible = false"
        >
          <p>确定</p>
        </div>
      </template>
    </hb-modal>

    <!-- cdkey获奖弹窗 -->
    <hb-modal :visible.sync="receiveModalVisible" class="cdk-receive">
      <template>
        <div class="cdk-img-area" v-if="!isLinkGacha">
          <div class="cdk-img-wrapper">
            <img :src="awardInfo.award_img" alt="" />
          </div>
        </div>
        <div class="close-icon" @click="receiveModalVisible = false">
          <img src="./assets/images/close.png" alt="" />
        </div>
        <div class="cdk-info" :class="{ 'link-award': isLinkGacha }">
          <p class="prize-name">
            {{ awardInfo.award_name }}
          </p>
          <div class="cdk-box" v-if="awardInfo.obtained_cdkey">
            <div class="cdk-wrapper">
              <div class="cdk-number">
                <p>{{ awardInfo.obtained_cdkey }}</p>
              </div>
            </div>
            <div
              class="copy-button"
              :style="mainColor"
              @click="copy"
              :data-clipboard-text="awardInfo.obtained_cdkey"
            >
              <p>复制</p>
            </div>
          </div>
          <div class="cdk-box" v-else>
            <div class="cdk-wrapper">
              <div class="cdk-number weak">
                <p>XXXXX-XXXXX-XXXXX</p>
              </div>
            </div>
          </div>
        </div>
        <div class="extra-info" v-if="!awardInfo.obtained_cdkey">
          <div class="lack-info">
            奖品采购中，到货后将通过站内信通知，敬请留意
          </div>
          <div class="lack-help" @click="openHelp">
            <span class="help-text">帮助功能与反馈</span>
            <hb-icon common-arrow-right-line></hb-icon>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div
          class="prize-btn"
          :style="mainColor"
          @click="receiveModalVisible = false"
        >
          <p>确定</p>
        </div>
      </template>
    </hb-modal>
  </div>
</template>

<script>
import { throttle } from 'lodash';
import cptRules from './components/cpt_rules';
import cptDetail from './components/cpt_detail';
import cptCarousel from './components/cpt_carousel';
import cptCountdown from './components/cpt-countdown';
import PageNav from '_com/base/page-nav/index.vue';
import ViewShareAward from './views/view-share-award.vue';
import {
  executeProtocolOutApp,
  executeProtocol,
  executeProtocolSync,
  pageChange,
  getOSType,
  getParams,
  showMessage,
  formDate,
  sendClientRequest,
  geVersion,
} from '_lib/utils';
import ClipboardJS from 'clipboard';

import {
  getRoomList,
  getTicketRank,
  getHomeInfo,
  getExpressInfo,
  getSharedInfo,
  getDataReport,
  getTicketList,
  upOwner,
  join,
  useBlankTicket,
  helpFriend,
} from '_api/tools/gacha.js';

export default {
  name: 'home',
  data() {
    return {
      isLoading: true,
      navHeight: 88,
      //数据组
      participantList: [],
      lotteryList: [],
      luckyNum: false,
      //是否能够参与抽奖
      gachaStatus: 1,
      //是否是实物
      //是否是分享页
      isShare: false,
      //盒券页面
      isShowMyLottery: false,
      isShowTaLottery: false,
      isShowRules: false,
      isShowCarousel: false,
      isShowDetail: false,
      //弹窗
      blankLotteryDialogVisible: false,
      gaChaDialogVisible: false,
      addLotteryDialogVisible: false,
      receiveDialogVisible: false,
      // receiveSuccessDialogVisible: false,
      is_show_addressed_dialog: false,
      //Modal
      deliverSuccessModalVisible: false,
      receiveModalVisible: false,

      errDialogVisible: false,
      inviteDialogVisible: false,
      frontTaskDialogVisible: false,
      is_delivered: false,
      is_addressed: false,
      //分享页数据
      moreList: [],
      isShowHelp: false,
      //是否助力
      isHelp: false,
      helperList: [],
      //base
      params: {},
      bgColorLeft: '',
      bgColorRight: '',
      btnColorLeft: '',
      btnColorRight: '',
      //抽奖页面数据
      inviteCode: '',
      awardInfo: {},
      taskList: [],
      offset: 0,
      limit: 20,
      lotteryOffset: 0,
      lotteryLimit: 20,
      totalTicket: 0,
      blankTicket: 0,
      canAdd: true,
      canMinus: false,
      moreTicket: 0,
      messageList: [],
      carousel: {
        heybox_info: {
          avatar: '',
        },
      },
      timer: '',
      myTicket: 0,
      temp: '',
      helpCode: false,
      helpedUserInfo: {},
      appUrl: '',
      detailText: '',
      //验证码
      phoneNumber: '',
      code: '',
      isSend: false,
      timeDown: 60,
      timeDownTimer: '',
      login: false,
      //房主信息
      owner: {},
      heyboxId: '',
      //错误信息
      //初次加载
      osType: '',
      firstLoad: true,
      canLoadPar: true,
      canLoadTa: true,
      canLoadMy: true,
      taTicketsNoMore: false,
      myTicketsNoMore: false,
      participantsNoMore: false,

      helpPro: '',
      //判断是否在max中
      isMax: false,
      TaAvatar: '',
      TaName: '',
      routeParam: {},
      express_info: {},
      link: null,
    };
  },
  created() {
    this.dealParams();
  },
  mounted() {
    pageChange(() => {
      if (this.isShare) {
        this.getShareData();
        this.getExpressInfo();
      } else {
        this.getData();
        this.getExpressInfo();
      }
    });
  },
  components: {
    cptRules,
    cptCarousel,
    cptDetail,
    ViewShareAward,
    cptCountdown,
    PageNav,
  },
  computed: {
    mainColor() {
      return (
        'background: linear-gradient(to right, ' +
        this.btnColorLeft +
        ' 0%, ' +
        this.btnColorRight +
        ' 100%);'
      );
    },
    fontColor() {
      return (
        'background: linear-gradient(to right, ' +
        this.btnColorLeft +
        ' 0%, ' +
        this.btnColorRight +
        ' 100%); background-clip: text; -webkit-background-clip: text; color: transparent;'
      );
    },
    receiveSuccessDialogVisible() {
      return this.is_show_addressed_dialog && !this.is_delivered;
    },
    isLinkGacha() {
      return this.awardInfo.creator_type === 1;
    },
  },
  methods: {
    //获取数据
    dealParams() {
      //判断机型
      if (['android', 'ios'].indexOf(getOSType().toLowerCase()) !== -1) {
        this.osType = getOSType().toLowerCase();
      } else {
        this.osType = 'web';
      }

      //处理url
      this.params = getParams();
      if (this.params.heybox_id) {
        this.heyboxId = this.params.heybox_id;
      }
      if (this.params.help_code) {
        this.helpCode = this.params.help_code;
      }
      if (this.params.is_share) {
        this.isShare = true;
        this.report();
        this.getShareData();
        this.getMoreGacha();
      } else {
        this.navHeight = Number(
          executeProtocolSync({ protocol_type: 'getNavigationBarHeight' }),
        );
        this.getData();
      }
      this.getExpressInfo();
      this.getParticipant();
    },
    getMoreGacha() {
      const params = {
        limit: 20,
      };
      getRoomList(params).then((res) => {
        if (res.data.status === 'ok') {
          this.moreList = res.data.result;
        }
      });
    },
    getParticipant() {
      if (!this.canLoadPar) {
        return;
      }
      //参与人
      this.canLoadPar = false;
      const params = {
        award_id: this.params.award_id,
        offset: this.offset,
        limit: this.limit,
      };
      getTicketRank(params).then((res) => {
        if (res.data.status === 'ok') {
          if (res.data.result.length) {
            this.participantList.push(...res.data.result);
            this.offset += res.data.result.length;
          } else {
            this.participantsNoMore = true;
          }
        }
        this.canLoadPar = true;
      });
    },
    getData() {
      //主要信息
      const params = {
        os_type: this.osType,
        award_id: this.params.award_id,
        client_type: this.params.client_type,
      };
      getHomeInfo(params).then((res) => {
        if (res.data.status === 'ok') {
          const data = res.data.result;
          this.bgColorLeft = data.award_info.color_left;
          this.bgColorRight = data.award_info.color_right;
          this.btnColorLeft = data.award_info.button_color_left;
          this.btnColorRight = data.award_info.button_color_right;
          this.awardInfo = data.award_info;
          this.taskList = data.task_list;
          this.owner = data.home_owner;
          this.link = data.link;
          if (data.help_protocol) {
            this.helpPro = data.help_protocol;
          }
          if (data.history_info) {
            this.messageList = data.history_info;
          }
          //按钮状态
          //前置任务
          if (data.front_task && data.award_info.status == 0) {
            //任务进行中
            this.frontTask = data.front_task[0];
            if (data.front_task[0].tips_desc) {
              //前置任务做了但是还在结算
              this.gachaStatus = 8;
            } else {
              //前置任务没做
              this.gachaStatus = 7;
            }
          } else {
            if (data.award_info.status === 0) {
              if (data.joined) {
                this.gachaStatus = 2;
              } else {
                this.gachaStatus = 1;
              }
            } else if (data.award_info.status === 1) {
              //开奖中
              this.gachaStatus = 6;
            } else if (
              data.award_info.status === 2 ||
              data.award_info.status == 3
            ) {
              //已开奖, 3表示cdkey采购中无现货
              if (data.award_info.is_winner) {
                this.gachaStatus = 4;
              } else {
                this.gachaStatus = 3;
              }
            }
            if (data.my_ticket) {
              this.myTicket = data.my_ticket;
            }
            if (data.help_code) {
              this.helpCode = data.help_code;
            }
          }
          this.isMax = data.is_max;
          if (data.award_info.award_detail) {
            this.detailText = data.award_info.award_detail;
          }
          if (data.logined) {
            this.login = true;
            if (data.heybox_id) {
              this.heyboxId = data.heybox_id;
            }
          }
          // 不是分享&是本人获奖&实物奖品&有地址信息返回，则展示选择完地址成功领奖弹窗
          if (
            !this.isShare &&
            this.gachaStatus === 4 &&
            this.awardInfo.award_type === 1 &&
            this.awardInfo.selected_address_info
          ) {
            this.is_addressed = true;
            this.is_show_addressed_dialog = true;
          }

          this.setCarousel();
          this.firstLoad = false;
          this.isLoading = false;
        }
      });
    },
    getExpressInfo() {
      getExpressInfo({
        award_id: this.params.award_id,
      }).then((res) => {
        if (res.data.status == 'ok') {
          let result = res.data.result;
          this.express_info.express_code = result.express_code;
          this.express_info.express_company = result.express_company;
          if (this.express_info.express_code) {
            this.is_delivered = true;
          }
        }
      });
    },
    getShareData() {
      const params = {
        award_id: this.params.award_id,
      };
      if (this.params.help_code) {
        params.help_code = this.params.help_code;
      }
      getSharedInfo(params).then((res) => {
        // res.data = require('./mock/share_help_data.json')
        if (res.data.status === 'ok') {
          const data = res.data.result;
          this.bgColorLeft = data.award_info.color_left;
          this.bgColorRight = data.award_info.color_right;
          this.btnColorLeft = data.award_info.button_color_left;
          this.btnColorRight = data.award_info.button_color_right;
          this.messageList = data.winner_list || [];
          this.awardInfo = data.award_info;
          this.appUrl = data.open_in_app;
          this.link = data.link;
          this.taskList = data.task_list;
          this.owner = data.home_owner;
          if (this.params.help_code) {
            this.helpedUserInfo = data.helped_user_info;
            //助力页面
            if (data.award_info.status === 0) {
              //分享页的助力 2
              this.gachaStatus = 2;
              this.helperList = data.shared_help_task_process.helper_list;
              this.isHelp = data.shared_help_task_process.is_helped;
            } else if (data.award_info.status === 1) {
              //结算中
              this.gachaStatus = 1;
            } else if (
              data.award_info.status === 2 ||
              data.award_info.status === 3
            ) {
              if (data.helped_is_winner) {
                this.gachaStatus = 4;
              } else {
                this.gachaStatus = 3;
              }
            }
          } else {
            //普通分享
            this.gachaStatus = 1;
          }
          if (data.logined) {
            this.login = true;
            if (data.heybox_id) {
              this.heyboxId = data.heybox_id;
            }
          }
          this.isLoading = false;
          this.setCarousel();
        }
      });
    },
    loadPar() {
      if (this.participantsNoMore) {
        return;
      }
      this.getParticipant();
    },
    loadMyLottery() {
      if (this.myTicketsNoMore) return;
      this.openMyLottery(false);
    },
    loadTaLottery() {
      if (this.taTicketsNoMore) return;
      this.openTaLottery(this.temp, false);
    },
    //完成任务
    finishTask(o) {
      if (o.task_key == 'open_wx_mini_program') {
        const formData = {
          report_type: 1,
          task_type: o.task_key,
          task_id: o.task_id,
        };
        getDataReport({}, formData);
        executeProtocol(o.jump_protocol);
      }
      if (o.task_name === '邀请新用户') {
        this.inviteCode = o.invite_code;
        this.inviteDialogVisible = true;
      } else {
        executeProtocol(o.jump_protocol);
      }
    },

    finishFrontTask(task) {
      if (this.gachaStatus == 8) {
        this.frontTaskDialogVisible = true;
      } else {
        const formData = {
          report_type: 1,
          task_type: task ? task.task_key : this.frontTask.task_key,
          task_id: task ? task.task_id : this.frontTask.task_id,
        };
        getDataReport({}, formData);
        executeProtocol(
          task ? task.jump_protocol : this.frontTask.jump_protocol,
        );
      }
    },
    toOwner() {
      executeProtocol(this.owner.jump_protocol);
    },
    upOwner() {
      var timetamp = Math.floor(new Date().getTime() / 1000);
      const params = {
        heybox_id: this.heyboxId,
        _time: timetamp,
      };
      const data = {
        following_id: this.owner.heybox_id,
      };
      upOwner(params, data).then((res) => {
        if (res.data.status === 'ok') {
          this.getData();
        }
      });
    },
    //打开盒券详情以及点击关闭
    openMyLottery(flag) {
      if (!this.canLoadMy) {
        return;
      }
      this.canLoadMy = false;
      this.isFixed = true;
      const params = {
        offset: this.lotteryOffset,
        limit: this.lotteryLimit,
        award_id: this.params.award_id,
        other_heybox_id: this.heyboxId,
      };
      getTicketList(params).then((res) => {
        if (res.data.status === 'ok') {
          if (res.data.result.list.length) {
            this.lotteryList.push(...res.data.result.list);
            this.lotteryOffset += res.data.result.list.length;
          } else {
            this.myTicketsNoMore = true;
          }
          this.totalTicket = res.data.result.total_ticket;
          this.blankTicket = res.data.result.blank_ticket_count;
          if (this.blankTicket === 0) {
            this.canAdd = false;
          }
          if (flag) {
            this.isShowMyLottery = true;
          }
        }
        this.canLoadMy = true;
      });
    },
    openTaLottery(item, flag) {
      if (!this.canLoadTa || this.isLinkGacha) {
        return;
      }
      this.canLoadTa = false;
      this.isFixed = true;
      this.temp = item;
      const params = {
        offset: this.lotteryOffset,
        limit: this.lotteryLimit,
        award_id: this.params.award_id,
        other_heybox_id: item.heybox_info.heybox_id,
      };
      getTicketList(params).then((res) => {
        if (res.data.status === 'ok') {
          if (res.data.result.list.length) {
            this.lotteryList.push(...res.data.result.list);
            this.lotteryOffset += res.data.result.list.length;
          } else {
            this.taTicketsNoMore = true;
          }
          this.totalTicket = res.data.result.total_ticket;
          this.luckyNum = res.data.result.winner_ticket;
          this.TaAvatar = item.heybox_info.avatar;
          this.TaName = item.heybox_info.username;
          if (flag) {
            this.isShowTaLottery = true;
          }
        }
        this.canLoadTa = true;
      });
    },
    clearAll() {
      this.code = '';
      this.phoneNumber = '';
      this.isShowHelp = false;
      this.isShowRules = false;
      this.isShowDetail = false;
      this.isFixed = false;
    },
    closeLottery() {
      this.lotteryList.splice(0, this.lotteryList.length);
      this.totalTicket = 0;
      this.lotteryOffset = 0;
      this.lotteryLimit = 20;
      this.luckyNum = false;
      this.canLoadTa = true;
      this.canLoadMy = true;
      this.isShowMyLottery = false;
      this.isShowTaLottery = false;
    },
    //弹窗的打开与关闭
    err(msg) {
      executeProtocol({
        protocol_type: 'alert',
        title: '错误',
        desc: msg,
        alert_type: 'state',
      });
    },
    gacha() {
      const query = { osType: this.osType };
      const formData = { award_id: this.params.award_id };

      sendClientRequest({
        url: '/store/roll_room_v2/join',
        type: 'POST',
        query: query,
        data: formData,
        need_encrypt: 0,
        protocol_options: {
          add_client_pkey: 1,
          needCookie: true,
        },
      })
        .then((content) => {
          if (content.status == 'ok') {
            this.getParticipant();
            if (!this.isLinkGacha) {
              this.gaChaDialogVisible = true;
            } else {
              this.getData();
            }
          }
        })
        .catch((err) => {
          if (!(getOSType() == 'Android' && !geVersion('1.3.315'))) {
            showMessage('failed', err);
          }
        });
    },
    addLottery() {
      this.addLotteryDialogVisible = true;
    },
    addConfirm() {
      const data = {
        award_id: this.params.award_id,
        use_count: this.moreTicket,
      };
      if (this.moreTicket !== 0) {
        useBlankTicket({}, data).then((res) => {
          if (res.data.status === 'ok') {
            this.getData();
            this.closeDialog();
            this.moreTicket = 0;
          }
        });
      } else {
        this.closeDialog();
      }
    },
    openRuleDialog() {
      this.blankLotteryDialogVisible = true;
    },
    closeDialog() {
      this.addLotteryDialogVisible = false;
      this.blankLotteryDialogVisible = false;
      this.is_show_addressed_dialog = false;
      this.receiveDialogVisible = false;
      this.inviteDialogVisible = false;
    },
    closeGachaDialog() {
      this.gaChaDialogVisible = false;
      this.frontTaskDialogVisible = false;
      this.getData();
    },
    //设置轮播
    setCarousel() {
      if (this.messageList.length === 0) {
        return;
      }
      clearInterval(this.timer);
      this.isShowCarousel = true;
      let flag = 0;
      this.carousel = this.messageList[flag];
      if (this.isShare) {
        this.carousel.title = `${this.carousel.heybox_info.username}<span>${this.carousel.time_desc}</span>${this.carousel.desc}`;
        console.log(this.carousel.title);
      }
      this.timer = setInterval(() => {
        flag++;
        if (flag === this.messageList.length) {
          flag = 0;
        }
        this.carousel = this.messageList[flag];
        if (this.isShare) {
          this.carousel.title = `${this.carousel.heybox_info.username}<span>${this.carousel.time_desc}</span>${this.carousel.desc}`;
        }
      }, 6000);
    },
    //打开规则页面与关闭
    openRules() {
      this.isShowRules = true;
      this.isFixed = true;
    },
    //邀请好友助力
    needHelp() {
      executeProtocol({
        protocol_type: 'share',
        title: this.helpPro.share_info.title,
        desc: this.helpPro.share_info.desc,
        share_url: this.helpPro.share_info.share_url,
        img_url: this.helpPro.share_info.img_url,
        act_id: this.helpPro.share_info.act_id,
      });
    },
    //分享页上报
    report() {
      const pageVisitImage = new Image();
      pageVisitImage.src =
        window.location.origin +
        '/game/upload_share_page_click/?source=roll_room_v2_' +
        this.params.award_id;
    },
    helpFriend() {
      const data = {
        help_code: this.helpCode,
      };
      helpFriend({}, data).then((res) => {
        if (res.data.status === 'ok') {
          this.getShareData();
        }
      });
    },
    openInApp() {
      window.location.href = this.appUrl;
    },
    helpToApp() {
      if (this.login) {
        this.helpFriend();
      } else {
        this.gotoApp();
      }
    },
    gotoApp() {
      let protocol = {
        protocol_type: 'openWindow',
        webview: {
          url:
            window.location.origin +
            '/store/roll_room_v2?help_code=' +
            this.helpCode +
            '&is_share=1&award_id=' +
            this.awardInfo.award_id +
            '&in_app=true&',
        },
      };
      if (this.isLinkGacha) {
        protocol.webview.url =
          window.location.origin +
          '/store/roll_room_v2?award_id=' +
          this.awardInfo.award_id +
          '&in_app=true&';
      }
      executeProtocolOutApp(protocol);
    },
    openHelp() {
      executeProtocol({
        protocol_type: 'openWindow',
        navigation_bar: {
          title: '小黑盒Roll房规则',
        },
        webview: {
          url: 'https://api.xiaoheihe.cn/bbs/app/feedback/faq/detail/page?seq_id=128&lang=zh-cn',
        },
      });
    },
    gotoGachaView() {
      executeProtocol({
        protocol_type: 'openWindow',
        webview: {
          url:
            window.location.origin +
            '/store/roll_room_v2?award_id=' +
            this.awardInfo.award_id +
            '&',
        },
      });
    },
    //领奖
    receive() {
      if (this.awardInfo.award_type === 1) {
        //实物
        if (!this.is_delivered) {
          executeProtocol({
            protocol_type: 'openWindow',
            webview: {
              url:
                window.location.origin +
                `/store/roll_room_v2/address_page?award_id=${this.awardInfo.award_id}`,
            },
          });
        } else {
          this.deliverSuccessModalVisible = true;
        }
      } else {
        //cdkey
        this.receiveModalVisible = true;
      }
    },
    copyCdkey(flag) {
      if (!flag) {
        var clipboard = new ClipboardJS('.cdkey-btn');
        clipboard.on('success', () => {
          showMessage('ok', '已成功复制cdkey到粘贴板');
        });
      } else {
        this.closeDialog();
        var clipboard = new ClipboardJS('.invite-btn');
        clipboard.on('success', () => {
          showMessage('ok', '已成功复制邀请码到粘贴板');
        });
      }
    },
    //查看全部名单
    toAllWinner(tag) {
      executeProtocol({
        protocol_type: 'openWindow',
        webview: {
          url:
            window.location.origin +
            '/store/roll_room_v2/winner_page?award_id=' +
            this.awardInfo.award_id +
            '&is_me=' +
            tag,
        },
      });
    },
    //打开用户页面
    openUser(item) {
      executeProtocol(item.jump_to_home);
    },
    copy() {
      var clipboard = new ClipboardJS('.copy-button');
      clipboard.on('success', () => {
        showMessage('ok', '复制成功！');
      });
    },
    toLinkPage() {
      executeProtocol(this.link.jump_protocol);
    },
    throttle,
    formDate,
  },
};
</script>

<style lang="less" scoped>
@import '~_style/common.css';
@import './assets/style/index.less';
</style>
